import { getPagePath, trans } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';

import LandingSection from '@spotahome/landings-common/src/components/LandingSection';

import TitleImage from './TitleImage';
import HeroImage from './HeroImage';

import './Hero.scss';

const Hero = () => {
  return (
    <LandingSection
      className="tenant-guarantees-hero"
      containerClassName="tenant-guarantees-hero__section-container"
    >
      <div className="tenant-guarantees-hero__container">
        <div className="tenant-guarantees-hero__logo">
          <TitleImage />
          <span className="tenant-guarantees-hero__logo-text">
            {trans('tenant_guarantees.hero.spotahome.guarantee')}
          </span>
        </div>
        <div className="tenant-guarantees-hero__text-content">
          <h1 className="tenant-guarantees-hero__title">
            {trans('tenant_guarantees.hero.title')}
          </h1>
          <Button
            color="primary"
            size="large"
            className="tenant-guarantees-hero__cta"
            href={getPagePath('landing')}
          >
            {trans('tenant_guarantees.hero.cta')}
          </Button>
        </div>
      </div>
      <div className="tenant-guarantees-hero__image-wrapper">
        <HeroImage className="tenant-guarantees-hero__image" />
      </div>
    </LandingSection>
  );
};

export default Hero;
